import tippy from 'tippy.js';

export default () => {

  tippy('[data-tippy-content]', {
    maxWidth: 320,
    interactive: true,
    appendTo: 'parent'
  });

};
